import React from 'react';
import { useHistory } from 'react-router-dom';

// @material-ui/core components
import { makeStyles } from '@material-ui/core/styles';

// core components
import Button from 'components/CustomButtons/Button';
import CustomInput from 'components/CustomInput/CustomInput';
import Card from 'components/Card/Card';
import CardBody from 'components/Card/CardBody';
import CardAvatar from 'components/Card/CardAvatar';
import CardFooter from 'components/Card/CardFooter';
import avatar from 'assets/img/default-avatar.png';

import styles from 'assets/jss/material-dashboard-pro-react/views/lockScreenPageStyle';

// ecm imports
import AuthService from 'services/auth.service';
import { store } from 'plugins/store/store';
import { setLockedActionCreator } from 'plugins/store/reducers/auth.reducer';
import { verifyLength } from 'plugins/validation/validation-rules';
import { useSnackbar } from 'notistack';
import SnackMessage from 'components/Snackbar/SnackMessage';
import layoutNames from 'utils/enums/layout-names.enum';

const useStyles = makeStyles(styles);

export default function LockScreenPage() {
	const [cardAnimaton, setCardAnimation] = React.useState('cardHidden');
	React.useEffect(() => {
		let id = setTimeout(function () {
			setCardAnimation('');
		}, 700);
		// Specify how to clean up after this effect:
		return function cleanup() {
			window.clearTimeout(id);
		};
	});
	const classes = useStyles();
	const history = useHistory();
	const [password, setPassword] = React.useState('');
	const [passwordState, setPasswordState] = React.useState('');
	const user = AuthService.getCurrentUser();
	const fullName = `${user?.firstName || ''} ${user?.lastName || ''}`;
	const userDisplayName = fullName === ' ' ? user?.username || 'USER' : fullName;

	const { enqueueSnackbar } = useSnackbar();
	const unlock = async (event) => {
		event.preventDefault();

		if (passwordState === '') {
			setPasswordState('error');
			return;
		}
		if (password) {
			try {
				const { authorized } = await AuthService.authorize(user.username, password);
				store.dispatch(setLockedActionCreator(!authorized));
				history.push('/home');
			} catch (e) {
				enqueueSnackbar(e.resolvedErrorMessage, {
					content: (key, message) => <SnackMessage id={key} message={message} color='danger' />,
				});
			}
		}
	};
	return (
		<div className={classes.container}>
			<form onSubmit={unlock}>
				<Card
					profile
					className={`${classes.customCardClass} ${classes[cardAnimaton]}`}
				>
					<CardAvatar profile className={classes.cardAvatar}>
						<a href='#pablo' onClick={e => e.preventDefault()}>
							<img src={avatar} alt='...' />
						</a>
					</CardAvatar>
					<CardBody profile>
						<h4 className={classes.cardTitle}>{userDisplayName}</h4>
						<CustomInput
							success={passwordState === 'success'}
							error={passwordState === 'error'}
							labelText='Enter Password'
							id='company-disabled'
							formControlProps={{
								fullWidth: true
							}}
							inputProps={{
								type: 'password',
								autoComplete: 'off'
							}}
							onChange={event => {
								if (verifyLength(event.target.value, 1)) {
									setPasswordState('inactive');
								} else {
									setPasswordState('error');
								}

								setPassword(event.target.value);
							}}
						/>
					</CardBody>
					<CardFooter className={classes.justifyContentCenter}>
						<div>
							<Button color='rose' round type='submit'>
								Unlock
							</Button>
							<div className={classes.stats}>
								<a
									href=""
									onClick={() => history.push(`/${layoutNames.auth}/login`)}
									className={classes.switchAccount}
								>
									Switch Account
								</a>
							</div>
						</div>
					</CardFooter>
				</Card>
			</form>
		</div>
	);
}
